import { lazy } from 'react';

export const AsyncRefundPageContainer = lazy(() => import(
  /* webpackChunkName: 'refund_page' */
  './RefundPageContainer'
));
